import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserStore } from '../../store/user.store';
import { AuthService } from '../../services/auth.service';

export const createGlobalAdminGuard = (): CanActivateFn => {
  return () => {
    const router = inject(Router);
    const userStore = inject(UserStore);
    const authService = inject(AuthService);

    if (!authService.isUserAuthenticated()) {
      router.navigate(['/login']);
      return false;
    }

    if (!userStore.isGlobalAdmin()) {
      router.navigate(['/not-allowed']);
      return false;
    }

    return true;
  };
};
